import { useRef } from 'react';

import { useBuildInfoContext } from '@/views/build/context/BuildInfoProvider';
import { useGetCategoryFormValue } from '@/views/build/features/category-form';
import { useBuildFormContext } from '@/views/build/form/schema';
import { getBuildType } from '@/views/build/util/getBuildType';

import { useSyncQuizTitleWithCategory } from '../../build-quiz-title';
import { quizSetupModal } from '../index';

export const useShowQuizSetupModal = () => {
  const {
    action,
    mapTemplates,
    schoolInfoTree,
    subjectTree,
    publishers,
    userCountryCode,
  } = useBuildInfoContext();
  const { setValue } = useBuildFormContext();

  // 카테고리 정보 form hook 사용
  const { getCategoryFormValue, updateCategoryFormValue } =
    useGetCategoryFormValue();
  const syncQuizTitleWithCategory = useSyncQuizTitleWithCategory({
    schoolInfoTree,
    subjectTree,
    publishers,
    userCountryCode,
  });

  const isOpened = useRef(false);

  const open = async () => {
    if (isOpened.current) return;
    isOpened.current = true;

    try {
      await quizSetupModal.openAsync({
        mapTemplates,
        schoolInfoTree,
        subjectTree,
        publishers,
        userCountryCode,
        buildType: getBuildType(action),
        initialCategoryInfoValues: getCategoryFormValue(schoolInfoTree),
        onMapComplete: (selectedMapTemplateId, mapTemplateType) => {
          setValue('templateId', selectedMapTemplateId, {
            shouldDirty: true,
          });
          setValue('templateType', mapTemplateType, {
            shouldDirty: true,
          });
        },
        onCategoryInfoComplete: values => {
          updateCategoryFormValue(values);
          syncQuizTitleWithCategory(values);
        },
      });
      return true;
    } catch (error) {
      console.error('Quiz setup modal error:', error);
      return false;
    } finally {
      isOpened.current = false;
    }
  };

  return { open };
};
